const TOKEN_KEY = 'access_token';
const REFRESH_TOKEN_KEY = 'refresh_token';
const REMEMBER_ME = 'remember_me';
const TOUR = 'tour';
const CURRENCY = 'currency';
const CASH = 'cash';
const CASH_ID = 'cash_id';
const TOUR_ID = 'tour_id';
const USER_ROLE = 'user_role';
const VOUCHER = 'voucher';
const PRE_VOUCHER = 'preInputVoucher';
const CLICK_CHANGE_PASS = 'clickChangePass';
const USER = 'user';
const OCR = "ocr";
const EXPIRED = "expired";
const LOGINVAL = "loginval";
const CASHNAME = "cashname";
const CASHKEYNAME = "cashkeyname";
const SPLOGIN_PW = "sploginedpw-user";
const VOUCHER_TYPE = "voucherType";
const DEVELOPER_NAME = "developername";
const USER_CASHKEYNAME = "user_cashkeyname";
const CURRENCY_ID = "currency_id";

const CryptoJS = require('crypto-js');

const encryptionKey = process.env.ENCRYPTION_KEY;

function encrypt (KEY, val) {
    const encrypted = CryptoJS.AES.encrypt(val, encryptionKey);
    localStorage.setItem(KEY, encrypted.toString());
}

function decrypt (KEY) {
    const encryptedData = localStorage.getItem(KEY);
    if (encryptedData == null) {
        return null;
    }
    const decrypted = CryptoJS.AES.decrypt(encryptedData, encryptionKey);
    return decrypted.toString(CryptoJS.enc.Utf8);
}

/**
 * Manage the how Access Tokens are being stored and retreived from storage.
 *
 * Current implementation stores to localStorage. Local Storage should always be
 * accessed through this instace.
**/
const StorageService = {

    getToken () {
        try {
            return decrypt(TOKEN_KEY);
        } catch (error) {
            this.removeToken();
        }
        // return `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjEiLCJ1c2VybmFtZSI6InNhbXBsZTAxQGdtYWlsLmNvbSIsImZ1bGxfbmFtZSI6InNhbXBsZTAxIiwicm9sZV9pZCI6MX0.AflRVn4wOwQdPj2lKaDSNe0TUMRlZZV1cTDSba7Hb8k`;
    },

    saveToken (accessToken) {
        encrypt(TOKEN_KEY, accessToken);
        // save user info
        let role;
        try {
            if (accessToken) {
                let Base64 = require('js-base64').Base64;
                // localUser = JSON.stringify(JSON.parse(Base64.decode(localStorage.getItem(TOKEN_KEY).split(".")[1])));
                role = parseInt(JSON.parse(Base64.decode(this.getToken().split(".")[1])).role);
            } else {
                role = null;
            }
        } catch (error) {
            role = null;
        }
        this.saveUserRole(role.toString());
    },

    removeToken () {
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(USER_ROLE);
    },

    getRefreshToken () {
        try {
            return decrypt(REFRESH_TOKEN_KEY);
        } catch (error) {
            this.removeRefreshToken();
        }
    },

    saveRefreshToken (refreshToken) {
        encrypt(REFRESH_TOKEN_KEY, refreshToken);
    },

    removeRefreshToken () {
        localStorage.removeItem(REFRESH_TOKEN_KEY);
    },

    getUserRole () {
        try {
            return decrypt(USER_ROLE);
        } catch (error) {
            localStorage.removeItem(USER_ROLE);
        }
    },

    saveUserRole (userRole) {
        if(userRole) encrypt(USER_ROLE, userRole.toString());
    },

    saveRememberMe (remember) {
        encrypt(REMEMBER_ME, remember);
    },

    removeRememberMe () {
        localStorage.removeItem(REMEMBER_ME);
    },

    getRememberMe () {
        try {
            return decrypt(REMEMBER_ME);
        } catch (error) {
            localStorage.removeItem(REMEMBER_ME);
        }
    },

    saveTour (tourInfo) {
        encrypt(TOUR, tourInfo);
    },

    removeTour () {
        localStorage.removeItem(TOUR);
        localStorage.removeItem(CASH);
        localStorage.removeItem(CASH_ID);
        localStorage.removeItem(TOUR_ID);
    },

    getTour () {
        try {
            return decrypt(TOUR);
        } catch (error) {
            localStorage.removeItem(TOUR);
        }
    },

    saveCurrency (currency) {
        encrypt(CURRENCY, currency);
    },

    removeCurrency () {
        localStorage.removeItem(CURRENCY);
    },

    getCurrency () {
        return decrypt(CURRENCY)
    },

    saveCashId (cashId) {
        if(cashId) encrypt(CASH, cashId.toString());
    },

    removeCashId () {
        localStorage.removeItem(CASH);
    },

    getCashId () {
        try {
            return decrypt(CASH);
        } catch (error) {
            localStorage.removeItem(CASH);
        }
    },

    // save, remove, get cash id server
    saveCashIdServer (cashId) {
        if(cashId) encrypt(CASH_ID, cashId.toString());
    },

    removeCashIdServer () {
        localStorage.removeItem(CASH_ID);
    },

    getCashIdServer () {
        try {
            return decrypt(CASH_ID);
        } catch (error) {
            localStorage.removeItem(CASH_ID);
        }
    },
    // end save, remove, get cash id local

    // save, remove, get tour id server
    saveTourIdServer (tourId) {
        if(tourId) encrypt(TOUR_ID, tourId.toString());
    },

    removeTourIdServer () {
        localStorage.removeItem(TOUR_ID);
    },

    getTourIdServer () {
        try {
            return decrypt(TOUR_ID);
        } catch (error) {
            localStorage.removeItem(TOUR_ID);
        }
    },
    // end save, remove, get tour id local

    saveVoucher (voucher) {
        encrypt(VOUCHER, voucher);
    },

    removeVoucher () {
        localStorage.removeItem(VOUCHER);
    },

    getVoucher () {
        try {
            return decrypt(VOUCHER);
        } catch (error) {
            localStorage.removeItem(VOUCHER);
        }
    },

    savePreInputVoucher(voucher) {
        encrypt(PRE_VOUCHER, voucher);
    },
    getPreInputVoucher() {
        try {
            return decrypt(PRE_VOUCHER);
        } catch (error) {
            localStorage.removeItem(PRE_VOUCHER);
        }
    },
    clearPreInputVoucher() {
        localStorage.removeItem(PRE_VOUCHER);
    },

    saveClickChangePass (flg) {
        if(flg) encrypt(CLICK_CHANGE_PASS, flg.toString());
    },
    getClickChangePass () {
        try {
            return JSON.parse(decrypt(CLICK_CHANGE_PASS));
        } catch (error) {
            localStorage.removeItem(CLICK_CHANGE_PASS);
        }
    },
    removeClickChangePass () {
        localStorage.removeItem(CLICK_CHANGE_PASS);
    },

    saveUser (user) {
        encrypt(USER, user);
    },
    getUser () {
        try {
            return decrypt(USER);
        } catch (error) {
            localStorage.removeItem(USER);
        }
    },
    removeUser () {
        localStorage.removeItem(USER);
    },
    getOcr () {
        try {
            return decrypt(OCR);
        } catch (error) {
            localStorage.removeItem(OCR);
        }
    },
    saveOcr (val) {
        if(val) encrypt(OCR, val.toString());
    },
    removeOcr () {
        localStorage.removeItem(OCR);
    },
    saveExpired () {
        encrypt(EXPIRED, true.toString());
    },
    getExpired () {
        try {
            return decrypt(EXPIRED);
        } catch (error) {
            localStorage.removeItem(EXPIRED);
        }
    },
    removeExpired () {
        localStorage.removeItem(EXPIRED);
    },
    saveLoginVal (val) {
        encrypt(LOGINVAL, val);
    },
    getLoginVal () {
        try {
            return decrypt(LOGINVAL);
        } catch (error) {
            localStorage.removeItem(LOGINVAL);
        }
    },
    removeLoginVal () {
        localStorage.removeItem(LOGINVAL);
    },
    saveCashName (val) {
        encrypt(CASHNAME, val);
    },
    getCashName () {
        try {
            return decrypt(CASHNAME);
        } catch (error) {
            localStorage.removeItem(CASHNAME);
        }
    },
    removeCashName () {
        localStorage.removeItem(CASHNAME);
    },
    saveCashKeyName (val) {
        encrypt(CASHKEYNAME, val);
    },
    getCashKeyName () {
        try {
            return decrypt(CASHKEYNAME);
        } catch (error) {
            localStorage.removeItem(CASHKEYNAME);
        }
    },
    removeCashKeyName () {
        localStorage.removeItem(CASHKEYNAME);
    },
    saveSpLoginPwRest(val) {
        if(val) encrypt(SPLOGIN_PW, val.toString())
    },
    getSpLoginPwRest() {
        try {
            return decrypt(SPLOGIN_PW);
        } catch (error) {
            localStorage.removeItem(SPLOGIN_PW);
        }
    },
    removeSpLoginPwRest() {
        localStorage.removeItem(SPLOGIN_PW)
    },
    saveVoucherType(val) {
        if(val) encrypt(VOUCHER_TYPE, val.toString());
    },
    getVoucherType() {
        try {
            return decrypt(VOUCHER_TYPE);
        } catch (error) {
            localStorage.removeItem(VOUCHER_TYPE);
        }
    },
    removeVoucherType() {
        localStorage.removeItem(VOUCHER_TYPE);
    },
    saveDeveloperName(val) {
        encrypt(DEVELOPER_NAME, val);
    },
    getDeveloperName() {
        try {
            return decrypt(DEVELOPER_NAME);
        } catch (error) {
            localStorage.removeItem(DEVELOPER_NAME);
        }
    },
    removeDeveloperName() {
        localStorage.removeItem(DEVELOPER_NAME);
    },
    saveUserCashKeyName(val) {
        encrypt(USER_CASHKEYNAME, val);
    },
    getUserCashKeyName() {
        try {
            return decrypt(USER_CASHKEYNAME);
        } catch (error) {
            localStorage.removeItem(USER_CASHKEYNAME);
        }
    },
    removeUserCashKeyName() {
        localStorage.removeItem(USER_CASHKEYNAME);
    },
    saveCurrencyId(val) {
        encrypt(CURRENCY_ID, val);
    },
    getCurrencyId() {
        try {
            return decrypt(CURRENCY_ID);
        } catch (error) {
            console.error(error.stack);
            localStorage.removeItem(CURRENCY_ID);
        }
    },
    removeCurrencyId() {
        localStorage.removeItem(CURRENCY_ID);
    }
};


export default StorageService;



// WEBPACK FOOTER //
// ./src/services/common/storage.service.js